import {
  EntityTypes,
  DefaultProjectionYear,
  SuperFundType,
} from "../helpers/constant";
import { CommonHelper } from "../helpers";
import RiskProfile from "./riskprofiles";
export default {
  getEmptySuperannuationModel(clientDetails) {
    let p = {};
    p.clientId = clientDetails.clientId;
    p.superFundId = 0;
    p.superBalance = 0;
    p.superFundGuid = "00000000-0000-0000-0000-000000000000";
    p.superannuationName = "";
    p.projectionYear = DefaultProjectionYear;
    p.description = "Superannuation & Retirement";
    p.s3FilePath = "";
    p.isFromFact = false;
    p.ownerDetails = [];
    p.otherDetail = [];
    p.fundDetails = [];
    p.superAdvanceDetails = [];
    p.superAddtionalDetails = [];
    p.nonSuperData = [];

    return p;
  },

  setSuperannuationInformation(payload, clientDetails, riskProfileData) {
    let parentClientInfo = clientDetails.filter(
      (sr) => sr.entityType == EntityTypes.client
    );
    return payload
      .filter((x) => x.superFundGuid != "00000000-0000-0000-0000-000000000000")
      .map((r) => {
        let p = {};

        p.clientId = parentClientInfo[0].clientId;
        p.selectClientIdForSuperFundEdit = parentClientInfo[0].clientId;
        p.s3FilePath = r.s3FilePath;
        p.superFundId = r.superFundId;

        p.description = r.superannuationName;
        p.superannuationName = r.superannuationName;
        p.parentSuperGuid = r.parentSuperGuid;

        p.superFundGuid = r.superFundGuid;

        p.name = "Balance";

        p.amount = r.amount;

        p.isFromFact = r.isFromFact;
        p.components = !r.components ? [] : r.components;
        p.ownerDetails = !r.ownerDetails ? [] : r.ownerDetails;

        p.otherDetail = !r.otherDetail ? [] : r.otherDetail;

        p.fundDetails = this.setFundDetails(
          clientDetails,
          r.fundDetails,
          riskProfileData
        );

        p.modifiedDate = r.modifiedDate;
        p.projectionYear =
          r.projectionYear == 0 || !r.projectionYear
            ? DefaultProjectionYear
            : r.projectionYear;

        p.nonSuperData = !r.nonSuperData ? [] : r.nonSuperData;

        p.superAdvanceDetails = !r.superAdvanceDetails
          ? []
          : r.superAdvanceDetails;
        p.superAddtionalDetails = !r.superAddtionalDetails
          ? []
          : r.superAddtionalDetails;

        for (let i = 0; i < p.superAddtionalDetails.length; i++) {
          let superAdditionalDate = p.superAddtionalDetails;
          superAdditionalDate[i].startDate =
            CommonHelper.convertDateToMonthYear(
              superAdditionalDate[i].startDate
            );
          superAdditionalDate[i].endDate =
            superAdditionalDate[i].endDate == null
              ? ""
              : CommonHelper.convertDateToMonthYear(
                  superAdditionalDate[i].endDate
                );
        }
        return p;
      });
  },

  setFundDetails(clientInfo, fundDetails, riskProfileData) {
    for (let i = 0; i < clientInfo.length; i++) {
      if (
        clientInfo[i].entityType == EntityTypes.client ||
        clientInfo[i].entityType == EntityTypes.partner
      ) {
        let funds = fundDetails.filter(
          (sr) => sr != undefined && sr.clientId == clientInfo[i].clientId
        );
        if (funds && funds.length == 0) {
          let riskprofiles = this.getRiskProfile(
            clientInfo[i].clientId,
            clientInfo[i].entityType,
            riskProfileData.defaultriskprofiles
          );
          let accumulations = this.resetRiskProfile(
            this.getDefaulAccumulationModel(),
            riskprofiles,
            clientInfo[i].clientId
          );
          fundDetails.push(accumulations);
          let pension = this.resetRiskProfile(
            this.getDefaulPensionModel(),
            riskprofiles,
            clientInfo[i].clientId
          );
          fundDetails.push(pension);
        }
      }
    }
    return fundDetails;
  },
  resetRiskProfile(fundDetails, riskProfile, clientId) {
    fundDetails.clientId = clientId;
    fundDetails.riskProfileId = riskProfile.profileId;
    fundDetails.incomeRate = riskProfile.incomeRate;
    fundDetails.growthRate = riskProfile.growthRate;
    fundDetails.frankingRate = riskProfile.frankingRate;
    return fundDetails;
  },
  setSuperannuationEntityInformation(clientInfo) {
    let entityInfo = clientInfo.map((r) => {
      if (
        r.entityType == EntityTypes.client ||
        r.entityType == EntityTypes.partner
      ) {
        let p = {};
        p.value = r.clientId;
        p.text = CommonHelper.stringtoPascal(r.clientName);
        p.ownerShort = r.ownerShort
          ? CommonHelper.stringtoPascal(r.ownerShort)
          : r.ownerShort;
        p.dob = CommonHelper.formatDate(r.dob, false, "/");
        p.gender = r.gender;
        p.entityType = r.entityType;
        p.id = r.entityType == EntityTypes.both ? 2.1 : r.entityType;
        return p;
      }
    });
    let selectedUser = entityInfo.filter((sr) => sr != undefined);
    if (selectedUser && selectedUser.length > 0) {
      selectedUser = selectedUser.sort(function (a, b) {
        return a.id - b.id;
      });
    }
    return selectedUser;
  },
  getSuperFundTab(clientInfo) {
    let tabs = [];
    for (let i = 0; i < clientInfo.length; i++) {
      tabs.push({
        text: clientInfo[i].ownerShort,
        id: clientInfo[i].value,
        active: false,
      });
    }
    if (tabs.length > 0) {
      tabs[0].active = true;
    }
    return tabs;
  },
  getSuperFundSection(clientInfo) {
    let sections = [];
    for (let i = 0; i < clientInfo.length; i++) {
      sections.push({
        sectionTabId: clientInfo[i].value,
        sectionTitle: `${clientInfo[i].ownerShort} Superannuation Accumulation`,
        sectionHeading: "Applicable if user has not yet retired",
        clientId: clientInfo[i].value,
        isExpand: i > 0 ? false : true,
      });
      sections.push({
        sectionTabId: clientInfo[i].value,
        sectionTitle: `${clientInfo[i].ownerShort} Superannuation Pension`,
        sectionHeading: "",
        clientId: clientInfo[i].value,
        isExpand: false,
      });
    }
    return sections;
  },
  getSectionGroupElements(clientInfo) {
    let groupSection = [];
    for (let i = 0; i < clientInfo.length; i++) {
      if (clientInfo[i].entityType == EntityTypes.client) {
        groupSection = groupSection.concat(
          this.clientAccumlationSectionElements(clientInfo[i].value)
        );
        groupSection = groupSection.concat(
          this.clientPensionSectionElements(clientInfo[i].value)
        );
      } else if (clientInfo[i].entityType == EntityTypes.partner) {
        groupSection = groupSection.concat(
          this.partnerAccumlationSectionElements(clientInfo[i].value)
        );
        groupSection = groupSection.concat(
          this.partnerPensionSectionElements(clientInfo[i].value)
        );
      }
    }
    return groupSection;
  },
  clientAccumlationSectionElements(clientid) {
    return {
      tabLinkId: `${clientid}_accumulation`,
      clientid: clientid,
      type: SuperFundType.Accumulation,
      groupElement: [
        {
          name: "RETURN",
          id: `${clientid}_accumulation_1`,
          tag: "AccumulationReturn",
          element: [0, 1, 2, 3, 46],
          uiProp: [
            { id: "0", value: "riskProfileId" },
            { id: "1", value: "incomeRate" },
            { id: "2", value: "growthRate" },
            { id: "3", value: "frankingRate" },
          ],
          subGroup: [],
          class: "",
        },
        {
          name: "CONTRIBUTIONS",
          tag: "AccumulationContribution",
          id: `${clientid}_accumulation_2`,
          uiProp: [
            { id: "4", value: "isUseSGC" },
            { id: "5", value: "employerAmount" },
            { id: "6", value: "employerDurationType" },
            { id: "7", value: "employerGrowthType" },
            { id: "8", value: "isEmployerMax" },
            { id: "9", value: "salarySacrificeAmount" },
            { id: "10", value: "salarySacrificeDurationType" },
            { id: "11", value: "salarySacrificeGrowthType" },
            { id: "12", value: "nonConcessionalAmount" },
            { id: "13", value: "nonConcessionalDurationType" },
            { id: "14", value: "nonConcessionalGrowthType" },
          ],
          subGroup: [
            {
              isInline: false,
              element: [4, 5],
              relativePosition: true,
            },
            {
              isInline: true,
              element: [6, 7],
            },
            {
              isInline: false,
              element: [8],
              uiProp: ["isEmployerMax"],
              addDefaultMargin: true,
            },
            {
              isInline: false,
              element: [9],

              addDefaultMargin: true,
            },
            {
              isInline: true,
              element: [10, 11],
            },
            {
              isInline: false,
              element: [12],

              addDefaultMargin: true,
            },
            {
              isInline: true,
              element: [13, 14],
            },
            {
              isInline: false,
              element: [47],
            },
          ],
          element: [],
          class: "group-section",
        },
      ],
    };
  },
  clientPensionSectionElements(clientid) {
    return {
      tabLinkId: `${clientid}_pension`,
      clientid: clientid,
      type: SuperFundType.Pension,
      groupElement: [
        {
          name: "RETURN",
          id: `${clientid}_pension_1`,
          tag: "PensionReturn",
          uiProp: [
            { id: "15", value: "riskProfileId" },
            { id: "16", value: "incomeRate" },
            { id: "17", value: "growthRate" },
            { id: "18", value: "frankingRate" },
          ],
          element: [15, 16, 17, 18, 48],
          subGroup: [],
          class: "",
        },
        {
          name: "Pension Payment",
          tag: "PensionPayment",
          id: `${clientid}_pension_2`,
          uiProp: [
            { id: "19", value: "paymentType" },
            { id: "20", value: "amount" },
            { id: "21", value: "durationType" },
            { id: "22", value: "growthType" },
          ],
          subGroup: [
            { isInline: false, element: [19] },
            { isInline: false, element: [20] },
            {
              isInline: true,
              element: [21, 22],
            },
            {
              isInline: false,
              element: [49],
            },
          ],
          element: [],
          class: "group-section",
        },
      ],
    };
  },
  partnerAccumlationSectionElements(clientid) {
    return {
      tabLinkId: `${clientid}_accumulation`,
      clientid: clientid,
      type: SuperFundType.Accumulation,
      groupElement: [
        {
          name: "RETURN",
          tag: "AccumulationReturn",

          uiProp: [
            { id: "23", value: "riskProfileId" },
            { id: "24", value: "incomeRate" },
            { id: "25", value: "growthRate" },
            { id: "26", value: "frankingRate" },
          ],
          element: [23, 24, 25, 26, 50],
          subGroup: [],
          class: "",
          id: `${clientid}_accumulation_1`,
        },
        {
          name: "CONTRIBUTIONS",
          id: `${clientid}_accumulation_2`,
          tag: "AccumulationContribution",
          uiProp: [
            { id: "27", value: "isUseSGC" },
            { id: "28", value: "employerAmount" },
            { id: "29", value: "employerDurationType" },
            { id: "30", value: "employerGrowthType" },
            { id: "31", value: "isEmployerMax" },
            { id: "32", value: "salarySacrificeAmount" },
            { id: "33", value: "salarySacrificeDurationType" },
            { id: "34", value: "salarySacrificeGrowthType" },
            { id: "35", value: "nonConcessionalAmount" },
            { id: "36", value: "nonConcessionalDurationType" },
            { id: "37", value: "nonConcessionalGrowthType" },
          ],
          subGroup: [
            {
              isInline: false,
              element: [27, 28],
              relativePosition: true,
            },
            {
              isInline: true,
              element: [29, 30],
            },
            { isInline: false, element: [31] },
            {
              isInline: false,
              element: [32],
              addDefaultMargin: true,
            },
            {
              isInline: true,
              element: [33, 34],
            },
            {
              isInline: false,
              element: [35],
              addDefaultMargin: true,
            },
            {
              isInline: true,
              element: [36, 37],
            },
            {
              isInline: false,
              element: [51],
            },
          ],
          element: [],
          class: "group-section",
        },
      ],
    };
  },
  partnerPensionSectionElements(clientid) {
    return {
      tabLinkId: `${clientid}_pension`,
      clientid: clientid,
      type: SuperFundType.Pension,
      groupElement: [
        {
          tag: "PensionReturn",
          name: "RETURN",
          id: `${clientid}_pension_1`,

          uiProp: [
            { id: "38", value: "riskProfileId" },
            { id: "39", value: "incomeRate" },
            { id: "40", value: "growthRate" },
            { id: "41", value: "frankingRate" },
          ],
          element: [38, 39, 40, 41, 52],
          subGroup: [],
          class: "",
        },
        {
          name: "Pension Payment",
          tag: "PensionPayment",
          id: `${clientid}_pension_2`,
          uiProp: [
            { id: "42", value: "paymentType" },
            { id: "43", value: "amount" },
            { id: "44", value: "durationType" },
            { id: "45", value: "growthType" },
          ],
          subGroup: [
            { isInline: false, element: [42] },
            { isInline: false, element: [43] },
            {
              isInline: true,
              element: [44, 45],
            },
            {
              isInline: false,
              element: [53],
            },
          ],
          element: [],
          class: "group-section",
        },
      ],
    };
  },
  partnerSectionElements() {},
  getSuperFundSectionElements(
    clientInfo,
    superfundData,
    riskProfiledata,
    frequencyOption,
    awoteOption,
    pensionOption
  ) {
    let formElements = [];
    let AdditionalElements = [];
    let isPartnerNotPresent = false;

    for (let i = 0; i < clientInfo.length; i++) {
      if (clientInfo.length == 1) {
        isPartnerNotPresent = true;
      }
      let data = this.getClientFormData(
        clientInfo[i],
        superfundData,
        riskProfiledata,
        frequencyOption,
        awoteOption,
        pensionOption
      );
      formElements = formElements.concat(data.accumulationElements);
      formElements = formElements.concat(data.pensionElements);
      if (isPartnerNotPresent) {
        let data = this.getClientFormData(
          { value: 0, entityType: EntityTypes.partner },
          superfundData,
          riskProfiledata,
          frequencyOption,
          awoteOption,
          pensionOption
        );
        formElements = formElements.concat(data.accumulationElements);
        formElements = formElements.concat(data.pensionElements);
      }
      let elements = this.getAdditionalFormElements(clientInfo[i].value);
      AdditionalElements = AdditionalElements.concat(elements);
    }

    // Start from 46
    AdditionalElements.push(
      this.getAdditionalElementModel("AdditionalFieldMarketCrash")
    );
    formElements = formElements.concat(AdditionalElements);
    return formElements;
  },

  getClientFormData(
    client,
    superfundData,
    riskProfiledata,
    frequencyOption,
    awoteOption,
    pensionOption
  ) {
    let riskProfile = this.getRiskProfile(
      client.value,
      client.entityType,
      riskProfiledata.defaultriskprofiles
    );
    let accumulationElements = this.getAllAccumulationFormElement(
      client.value,
      superfundData.fundDetails,
      riskProfile,
      riskProfiledata.data,
      frequencyOption,
      awoteOption
    );
    let pensionElements = this.getAllPensionFormElement(
      client.value,
      superfundData.fundDetails,
      riskProfile,
      riskProfiledata.data,
      pensionOption,
      frequencyOption,
      awoteOption
    );
    return {
      accumulationElements: accumulationElements,
      pensionElements: pensionElements,
    };
  },

  getAdditionalFormElements(clientId) {
    let elements = [];

    // Element Start from 46 here
    elements.push(
      this.getAdditionalElementModel("AdditionalFieldAccumulation" + clientId)
    );
    elements.push(
      this.getAdditionalElementModel("AdditionalFieldContribution" + clientId)
    );
    elements.push(
      this.getAdditionalElementModel("AdditionalFieldPensionReturn" + clientId)
    );
    elements.push(
      this.getAdditionalElementModel("AdditionalFieldPensionPayment" + clientId)
    );

    return elements;
  },
  getAdditionalElementModel(name) {
    return {
      type: "FormField",
      name: "Adjustment",
      dataType: "text",
      displayType: "AdditionalInformation",
      htmlName: name,
      groupId: "",
      options: [],
    };
  },
  getSubmitFormElement(resetButtonStatus) {
    return [
      {
        type: "FormField",
        id: "374",
        name: "Update",
        style: "",

        variation: "primary",
        displayType: "submit",
        htmlName: "submit",
        emitevent: "reloadSuperGraph",
        validations: [],
      },
      {
        type: "FormField",
        id: "375",
        name: "Reset",
        style: '{"margin-left":"20px"}',
        displayType: "submit",
        variation: "secondary",
        htmlName: "submit",
        emitevent: "onReset",
        isdisabled: resetButtonStatus,
        validations: [],
      },
      {
        type: "FormField",
        id: "376",
        name: "Advanced",
        style: '{"margin-left":"20px"}',
        dataType: "text",
        displayType: "link",
        emitevent: "openAdvancedFilter",
        htmlName: "link",
        isdisabled: true,
        validations: [],
      },
    ];
  },
  getAllAccumulationFormElement(
    clientId,
    superfundData,
    riskProfile,
    riskProfileOptions,
    frequencyOption,
    awoteOption
  ) {
    let clientAccumulationData = this.getAccumulationModel(
      clientId,
      superfundData,
      riskProfile,
      riskProfileOptions
    );
    let unModifiedSuperfundData = Object.assign({}, clientAccumulationData);

    return this.getAccumulationElements(
      clientAccumulationData,
      unModifiedSuperfundData,
      riskProfileOptions,
      clientId + "accumulation",
      frequencyOption,
      awoteOption,
      clientId
    );
  },
  getAllPensionFormElement(
    clientId,
    superfundData,
    riskProfile,
    riskProfileOptions,
    pensionOption,
    frequencyOption,
    awoteOption
  ) {
    let clientPensionData = this.getPensionModel(
      clientId,
      superfundData,
      riskProfile,
      riskProfileOptions
    );
    let unModifiedSuperfundData = Object.assign({}, clientPensionData);

    return this.getPensionElements(
      clientPensionData,
      unModifiedSuperfundData,
      riskProfileOptions,
      clientId + "pension",
      pensionOption,
      frequencyOption,
      awoteOption,
      clientId
    );
  },

  getRiskProfile(clientId, entityType, riskProfileData) {
    return RiskProfile.getRiskProfile(riskProfileData, 0, clientId, entityType);
  },
  getDefaulAccumulationModel() {
    return {
      clientId: 0,
      riskProfileId: -1,
      incomeRate: 0,
      growthRate: 0,
      frankingRate: 0,
      fundType: SuperFundType.Accumulation,
      contribution: {
        employerAmount: 0,
        isUseSGC: true,
        employerDurationType: 1,
        employerGrowthType: 1,
        isEmployerMax: false,
        salarySacrificeAmount: 0,
        salarySacrificeDurationType: 1,
        salarySacrificeGrowthType: 1,
        nonConcessionalAmount: 0,
        nonConcessionalDurationType: 1,
        nonConcessionalGrowthType: 1,
      },
    };
  },
  getDefaulPensionModel() {
    return {
      riskProfileId: -1,
      incomeRate: 0,
      growthRate: 0,
      frankingRate: 0,
      fundType: SuperFundType.Pension,
      pensionPayment: {
        paymentType: 1,
        amount: 0,
        durationType: 1,
        growthType: 1,
      },
    };
  },

  getAccumulationModel(
    clientId,
    superfundData,
    riskProfile,
    riskProfileOptions
  ) {
    let saveFundObject = superfundData.filter(
      (sr) =>
        sr.clientId == clientId && sr.fundType == SuperFundType.Accumulation
    );

    if (saveFundObject.length == 0) {
      saveFundObject = this.getDefaulAccumulationModel();
    } else {
      saveFundObject = saveFundObject[0];
    }
    let clientAccumulationData = {
      clientId: clientId,
      riskProfileId:
        saveFundObject.riskProfileId >= 0
          ? RiskProfile.getRiskProfileId(
              riskProfileOptions,
              saveFundObject.riskProfileId
            )
          : riskProfile.profileId,
      incomeRate:
        saveFundObject.riskProfileId >= 0
          ? saveFundObject.incomeRate
          : riskProfile.incomeRate,
      growthRate:
        saveFundObject.riskProfileId >= 0
          ? saveFundObject.growthRate
          : riskProfile.growthRate,
      frankingRate:
        saveFundObject.riskProfileId >= 0
          ? saveFundObject.frankingRate
          : riskProfile.frankingRate,
      employerAmount: saveFundObject.contribution.employerAmount,
      isUseSGC: saveFundObject.contribution.isUseSGC,
      employerDurationType: saveFundObject.contribution.employerDurationType,
      employerGrowthType: saveFundObject.contribution.employerGrowthType,
      isEmployerMax: saveFundObject.contribution.isEmployerMax,
      salarySacrificeAmount: saveFundObject.contribution.salarySacrificeAmount,
      salarySacrificeDurationType:
        saveFundObject.contribution.salarySacrificeDurationType,
      salarySacrificeGrowthType:
        saveFundObject.contribution.salarySacrificeGrowthType,
      nonConcessionalAmount: saveFundObject.contribution.nonConcessionalAmount,
      nonConcessionalDurationType:
        saveFundObject.contribution.nonConcessionalDurationType,
      nonConcessionalGrowthType:
        saveFundObject.contribution.nonConcessionalGrowthType,
    };
    return clientAccumulationData;
  },
  getPensionModel(clientId, superfundData, riskProfile, riskProfileOptions) {
    let saveFundObject = superfundData.filter(
      (sr) => sr.clientId == clientId && sr.fundType == SuperFundType.Pension
    );
    if (saveFundObject.length == 0) {
      saveFundObject = this.getDefaulPensionModel();
    } else {
      saveFundObject = saveFundObject[0];
    }
    let clientPensionData = {
      clientId: clientId,
      riskProfileId:
        saveFundObject.riskProfileId >= 0
          ? RiskProfile.getRiskProfileId(
              riskProfileOptions,
              saveFundObject.riskProfileId
            )
          : riskProfile.profileId,
      incomeRate:
        saveFundObject.riskProfileId >= 0
          ? saveFundObject.incomeRate
          : riskProfile.incomeRate,
      growthRate:
        saveFundObject.riskProfileId >= 0
          ? saveFundObject.growthRate
          : riskProfile.growthRate,
      frankingRate:
        saveFundObject.riskProfileId >= 0
          ? saveFundObject.frankingRate
          : riskProfile.frankingRate,
      paymentType: saveFundObject.pensionPayment.paymentType,
      amount: saveFundObject.pensionPayment.amount,
      durationType: saveFundObject.pensionPayment.durationType,
      growthType: saveFundObject.pensionPayment.growthType,
    };
    return clientPensionData;
  },
  getAccumulationElements(
    fundData,
    unModifiedSuperfundData,
    riskProfileData,
    uniqueId,
    frequencyOption,
    awoteOption,
    ownerId
  ) {
    return [
      {
        type: "FormField",
        id: `${uniqueId}1`,
        name: "Risk Profile",
        dataType: "text",
        displayType: "singleSelect",
        htmlName: "riskProfile",
        options: riskProfileData,
        defaultValue: unModifiedSuperfundData.riskProfileId,
        lastUserEnteredValue: fundData.riskProfileId,
        value: fundData.riskProfileId,
        emitevent: "onChangeRiskProfile",
        groupId: `${ownerId}_accumulation_1`,
        validations: [],
        ishide: false,
      },
      {
        type: "FormField",
        id: `${uniqueId}2`,
        name: "Income",
        dataType: "text",
        displayType: "slider",
        htmlName: "incomeRate",
        step: 0.25,
        options: [],
        defaultValue: unModifiedSuperfundData.incomeRate,
        value: fundData.incomeRate,
        lastUserEnteredValue: fundData.incomeRate,
        minValue: 0,
        isShowDecimal: true,
        maxValue: 15,
        inputMax: 99.99,
        validations: [],
        inputFormat: "%",
        groupId: `${ownerId}_accumulation_1`,
        ishide: false,
        maxlength: 5,
      },
      {
        type: "FormField",
        id: `${uniqueId}3`,
        name: "Growth",
        dataType: "text",
        displayType: "slider",
        htmlName: "growthRate",
        step: 0.25,
        options: [],
        isShowDecimal: true,
        defaultValue: unModifiedSuperfundData.growthRate,
        value: fundData.growthRate,
        lastUserEnteredValue: fundData.growthRate,
        minValue: 0,
        maxValue: 15,
        inputMax: 99.99,
        validations: [],
        inputFormat: "%",
        groupId: `${ownerId}_accumulation_1`,
        ishide: false,
        maxlength: 5,
      },
      {
        type: "FormField",
        id: `${uniqueId}4`,
        name: "Franking",
        dataType: "text",
        displayType: "slider",
        htmlName: "frankingRate",
        isShowDecimal: true,
        step: 5,
        options: [],
        defaultValue: unModifiedSuperfundData.frankingRate,
        value: fundData.frankingRate,
        lastUserEnteredValue: fundData.frankingRate,
        minValue: 0,
        maxValue: 100,
        inputMax: 99,
        validations: [],
        inputFormat: "%",
        additionalInfo: ownerId,
        groupId: `${ownerId}_accumulation_1`,
        ishide: false,
        maxlength: 5,
      },
      {
        type: "FormField",
        id: `${uniqueId}5`,
        name: "Use SGC",
        text: "Employer",
        displayType: "switchIcon",
        htmlName: "isUseSGC",
        tooltipMessage: "2024- 11%",
        defaultValue: unModifiedSuperfundData.isUseSGC,
        lastUserEnteredValue: fundData.isUseSGC,
        value: fundData.isUseSGC,
        position: "rightBelow",
        additionalInfo: ownerId,
        groupId: `${ownerId}_accumulation_2`,
        ishide: false,
      },
      {
        type: "FormField",
        id: `${uniqueId}6`,
        name: "",
        dataType: "text",
        displayType: "slider",
        htmlName: "contributionAmount",
        options: [],
        defaultValue: unModifiedSuperfundData.employerAmount,
        value: fundData.employerAmount,
        lastUserEnteredValue: fundData.employerAmount,
        minValue: 0,
        maxValue: 5000,
        inputMax: 999999999,
        step: 100,
        validations: [],
        inputFormat: "$,",
        isCurrencyFormat: true,
        additionalInfo: ownerId,
        groupId: `${ownerId}_accumulation_2`,
        ishide: fundData.isUseSGC ? true : false,
        maxlength: 9,
      },
      {
        type: "FormField",
        id: `${uniqueId}7`,
        name: "",
        dataType: "text",
        displayType: "popover",
        htmlName: "employerDurationType",
        options: frequencyOption,
        defaultValue: unModifiedSuperfundData.employerDurationType,
        lastUserEnteredValue: fundData.employerDurationType,
        value: fundData.employerDurationType,
        additionalInfo: ownerId,
        groupId: `${ownerId}_accumulation_2`,
        ishide: fundData.isUseSGC ? true : false,
      },
      {
        type: "FormField",
        id: `${uniqueId}8`,
        name: "",
        dataType: "text",
        displayType: "popover",
        htmlName: "employerGrowthType",
        options: awoteOption,
        defaultValue: unModifiedSuperfundData.employerGrowthType,
        lastUserEnteredValue: fundData.employerGrowthType,
        value: fundData.employerGrowthType,
        additionalInfo: ownerId,
        groupId: `${ownerId}_accumulation_2`,
        ishide: fundData.isUseSGC ? true : false,
      },
      {
        type: "FormField",
        id: `${uniqueId}9`,
        name: "max",
        dataType: "text",
        displayType: "checkbox",
        htmlName: "isEmployerMax",
        defaultValue: fundData.isEmployerMax,
        lastUserEnteredValue: fundData.isEmployerMax,
        value: fundData.isEmployerMax,
        additionalInfo: ownerId,
        groupId: `${ownerId}_accumulation_2`,
        ishide: true,
      },
      {
        type: "FormField",
        id: `${uniqueId}10`,
        name: "Salary Sacrifice",
        dataType: "text",
        displayType: "slider",
        htmlName: "salarySacrifice",
        options: [],
        defaultValue: unModifiedSuperfundData.salarySacrificeAmount,
        value: fundData.salarySacrificeAmount,
        lastUserEnteredValue: fundData.salarySacrificeAmount,
        minValue: 0,
        maxValue: 27500,
        inputMax: 999999999,
        step: 100,
        validations: [],
        inputFormat: "$,",
        isCurrencyFormat: true,
        additionalInfo: ownerId,
        groupId: `${ownerId}_accumulation_2`,
        maxlength: 9,
      },
      {
        type: "FormField",
        id: `${uniqueId}11`,
        name: "",
        dataType: "text",
        displayType: "popover",
        htmlName: "popover",
        options: frequencyOption,
        defaultValue: unModifiedSuperfundData.salarySacrificeDurationType,
        lastUserEnteredValue: fundData.salarySacrificeDurationType,
        value: fundData.salarySacrificeDurationType,
        additionalInfo: ownerId,
        groupId: `${ownerId}_accumulation_2`,
      },
      {
        type: "FormField",
        id: `${uniqueId}12`,
        name: "",
        dataType: "text",
        displayType: "popover",
        htmlName: "popover",
        options: awoteOption,
        defaultValue: unModifiedSuperfundData.salarySacrificeGrowthType,
        lastUserEnteredValue: fundData.salarySacrificeGrowthType,
        value: fundData.salarySacrificeGrowthType,
        additionalInfo: ownerId,
        groupId: `${ownerId}_accumulation_2`,
      },

      {
        type: "FormField",
        id: `${uniqueId}13`,
        name: "Non-Concessional",
        dataType: "text",
        displayType: "slider",
        htmlName: "nonConcessional",
        options: [],
        defaultValue: unModifiedSuperfundData.nonConcessionalAmount,
        value: fundData.nonConcessionalAmount,
        lastUserEnteredValue: fundData.nonConcessionalAmount,
        minValue: 0,
        maxValue: 110000,
        inputMax: 999999999,
        step: 100,
        validations: [],
        inputFormat: "$,",
        isCurrencyFormat: true,
        additionalInfo: ownerId,
        groupId: `${ownerId}_accumulation_2`,
        maxlength: 9,
      },
      {
        type: "FormField",
        id: `${uniqueId}14`,
        name: "",
        dataType: "text",
        displayType: "popover",
        htmlName: "popover",
        options: frequencyOption,
        defaultValue: unModifiedSuperfundData.nonConcessionalDurationType,
        lastUserEnteredValue: fundData.nonConcessionalDurationType,
        value: fundData.nonConcessionalDurationType,
        additionalInfo: ownerId,
        groupId: `${ownerId}_accumulation_2`,
      },
      {
        type: "FormField",
        id: `${uniqueId}15`,
        name: "",
        dataType: "text",
        displayType: "popover",
        htmlName: "popover",
        options: awoteOption,
        defaultValue: unModifiedSuperfundData.nonConcessionalGrowthType,
        lastUserEnteredValue: fundData.nonConcessionalGrowthType,
        value: fundData.nonConcessionalGrowthType,
        additionalInfo: ownerId,
        groupId: `${ownerId}_accumulation_2`,
      },
    ];
  },
  getPensionElements(
    fundData,
    unModifiedSuperfundData,
    riskProfileData,
    uniqueId,
    pensionOption,
    frequencyOption,
    awoteOption,
    ownerId
  ) {
    return [
      {
        type: "FormField",
        id: `${uniqueId}1`,
        name: "Risk Profile",
        dataType: "text",
        displayType: "singleSelect",
        htmlName: "riskProfile",
        options: riskProfileData,
        defaultValue: unModifiedSuperfundData.riskProfileId,
        lastUserEnteredValue: fundData.riskProfileId,
        value: fundData.riskProfileId,
        emitevent: "onChangeRiskProfile",
        validations: [],
        groupId: `${ownerId}_pension_1`,
      },
      {
        type: "FormField",
        id: `${uniqueId}2`,
        name: "Income",
        dataType: "text",
        displayType: "slider",
        htmlName: "incomeRate",
        step: 0.25,
        options: [],
        defaultValue: unModifiedSuperfundData.incomeRate,
        value: fundData.incomeRate,
        lastUserEnteredValue: fundData.incomeRate,
        minValue: 0,
        isShowDecimal: true,
        maxValue: 15,
        inputMax: 100,
        validations: [],
        ownerId: ownerId,
        inputFormat: "%",
        groupId: `${ownerId}_pension_1`,
      },
      {
        type: "FormField",
        id: `${uniqueId}3`,
        name: "Growth",
        dataType: "text",
        displayType: "slider",
        htmlName: "growthRate",
        step: 0.25,
        options: [],
        isShowDecimal: true,
        defaultValue: unModifiedSuperfundData.growthRate,
        value: fundData.growthRate,
        lastUserEnteredValue: fundData.growthRate,
        minValue: 0,
        maxValue: 15,
        inputMax: 100,
        validations: [],
        inputFormat: "%",
        groupId: `${ownerId}_pension_1`,
      },
      {
        type: "FormField",
        id: `${uniqueId}4`,
        name: "Franking",
        dataType: "text",
        displayType: "slider",
        htmlName: "frankingRate",
        isShowDecimal: true,
        step: 5,
        options: [],
        defaultValue: unModifiedSuperfundData.frankingRate,
        value: fundData.frankingRate,
        lastUserEnteredValue: fundData.frankingRate,
        minValue: 0,
        maxValue: 100,
        inputMax: 99,
        validations: [],
        inputFormat: "%",
        groupId: `${ownerId}_pension_1`,
      },
      {
        type: "FormField",
        id: `${uniqueId}5`,
        name: "Payment Type",
        dataType: "text",
        displayType: "singleSelect",
        htmlName: "paymentType",
        options: pensionOption,
        defaultValue: unModifiedSuperfundData.paymentType,
        value: fundData.paymentType,
        lastUserEnteredValue: fundData.paymentType,
        emitevent: "onChangePension",
        validations: [],
        ownerId: ownerId,
        groupId: `${ownerId}_pension_2`,
      },
      {
        type: "FormField",
        id: `${uniqueId}6`,
        name: "Amount",
        dataType: "text",
        displayType: "slider",
        htmlName: "pensionAmount",
        isdisabled: fundData.paymentType == 1 ? true : false,
        options: [],
        defaultValue:
          unModifiedSuperfundData.paymentType == 1
            ? 0
            : unModifiedSuperfundData.amount,
        value: fundData.paymentType == 1 ? 0 : fundData.amount,
        lastUserEnteredValue: fundData.paymentType == 1 ? 0 : fundData.amount,
        minValue: 0,
        maxValue: 5000,
        inputMax: 999999,
        step: 100,
        validations: [],
        inputFormat: "$,",
        isCurrencyFormat: true,
        groupId: `${ownerId}_pension_2`,
      },
      {
        type: "FormField",
        id: `${uniqueId}7`,
        name: "",
        dataType: "text",
        displayType: "popover",
        htmlName: "popover",
        options: frequencyOption,
        defaultValue: unModifiedSuperfundData.durationType,
        lastUserEnteredValue: fundData.durationType,
        value: fundData.durationType,
        groupId: `${ownerId}_pension_2`,
      },
      {
        type: "FormField",
        id: `${uniqueId}8`,
        name: "",
        dataType: "text",
        displayType: "popover",
        htmlName: "popover",
        options: awoteOption,
        defaultValue: unModifiedSuperfundData.growthType,
        lastUserEnteredValue: fundData.growthType,
        value: fundData.growthType,
        groupId: `${ownerId}_pension_2`,
      },
    ];
  },
  resetFundDetails(fundForm, fundSections) {
    let fundDetails = [];
    let fundDetail = {};
    for (let i = 0; i < fundSections.length; i++) {
      if (fundSections[i].type == SuperFundType.Accumulation) {
        fundDetail = this.getAccumationDataFromFormElement(
          fundForm,
          fundSections[i].groupElement
        );
      } else {
        fundDetail = this.getPensionDataFromFormElement(
          fundForm,
          fundSections[i].groupElement
        );
      }
      fundDetail.clientId = fundSections[i].clientid;
      fundDetails.push(fundDetail);
    }
    return fundDetails;
  },

  resetSuperAccumulationDetails(fundForm, elements, fundSections) {
    for (let i = 0; i < fundSections.length; i++) {
      let data = fundForm.filter(
        (sr) =>
          sr.clientId == fundSections[i].clientid &&
          sr.fundType == fundSections[i].type
      );
      if (data.length > 0) {
        this.setAccumationDataFromFormElement(
          data[0],
          elements,
          fundSections[i].groupElement
        );
      }
    }
  },
  setAccumationDataFromFormElement(fundForm, elements, groupElement) {
    for (let k = 0; k < groupElement.length; k++) {
      for (let i = 0; i < groupElement[k].uiProp.length; i++) {
        if (groupElement[k].tag == "AccumulationReturn") {
          elements[groupElement[k].uiProp[i].id].value =
            fundForm[groupElement[k].uiProp[i].value];
        } else if (groupElement[k].tag == "AccumulationContribution") {
          elements[groupElement[k].uiProp[i].id].value =
            fundForm.contribution[groupElement[k].uiProp[i].value];
        } else if (groupElement[k].tag == "PensionReturn") {
          elements[groupElement[k].uiProp[i].id].value =
            fundForm[groupElement[k].uiProp[i].value];
        } else if (groupElement[k].tag == "PensionPayment") {
          elements[groupElement[k].uiProp[i].id].value =
            fundForm.pensionPayment[groupElement[k].uiProp[i].value];
        }
      }
    }
  },
  getAccumationDataFromFormElement(fundForm, groupElement) {
    let fundDetail = this.getDefaulAccumulationModel();
    for (let k = 0; k < groupElement.length; k++) {
      for (let i = 0; i < groupElement[k].uiProp.length; i++) {
        if (groupElement[k].tag == "AccumulationReturn") {
          fundDetail[groupElement[k].uiProp[i].value] =
            fundForm[groupElement[k].uiProp[i].id].value;
        } else if (groupElement[k].tag == "AccumulationContribution") {
          fundDetail["contribution"][groupElement[k].uiProp[i].value] =
            fundForm[groupElement[k].uiProp[i].id].value;
        }
      }
    }
    return fundDetail;
  },
  getPensionDataFromFormElement(fundForm, groupElement) {
    let fundDetail = this.getDefaulPensionModel();

    for (let k = 0; k < groupElement.length; k++) {
      for (let i = 0; i < groupElement[k].uiProp.length; i++) {
        if (groupElement[k].tag == "PensionReturn") {
          fundDetail[groupElement[k].uiProp[i].value] =
            fundForm[groupElement[k].uiProp[i].id].value;
        } else if (groupElement[k].tag == "PensionPayment") {
          fundDetail["pensionPayment"][groupElement[k].uiProp[i].value] =
            fundForm[groupElement[k].uiProp[i].id].value;
        }
      }
    }
    return fundDetail;
  },
};
